module.exports = __webpack_public_path__ + "img/map-icon-taptakeover.ea788ab2.png";